import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=63996dba&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports